var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,457.3c-114.3,0-207.3-93-207.3-207.3S135.7,42.7,250,42.7s207.3,93,207.3,207.3S364.3,457.3,250,457.3 z M250,60c-49.2,0-90.7,87-90.7,190s41.5,190,90.7,190s90.7-87,90.7-190S299.2,60,250,60z M301.6,67.1 C335.4,101.7,358,169.9,358,250s-22.5,148.3-56.4,182.9C381.4,410.3,440,336.9,440,250S381.4,89.7,301.6,67.1z M198.4,67.1 C118.6,89.7,60,163.1,60,250s58.6,160.3,138.4,182.9C164.6,398.3,142,330.1,142,250S164.6,101.7,198.4,67.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.7,353.8H77.3c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h345.4c4.9,0,8.8,3.9,8.8,8.8 S427.6,353.8,422.7,353.8z M422.7,163.8H77.3c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h345.4c4.9,0,8.8,3.9,8.8,8.8 S427.6,163.8,422.7,163.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "258.6,448.6 241.4,448.6 241.4,258.6 51.4,258.6 51.4,241.4 241.4,241.4 241.4,51.4 258.6,51.4  258.6,241.4 448.6,241.4 448.6,258.6 258.6,258.6  "
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechNetwork;